import { DataServer } from "../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface TpiReportedIssuesState {
  TpiReportedIssues: {
    load: boolean;
    data: [];
  };
}

export const TpiReportedIssuesSlice = createSlice({
  name: "TpiReportedIssues",
  initialState: {
    TpiReportedIssues: {
      load: false,
      data: [],
    },
  } as TpiReportedIssuesState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchTpiReportedIssues.pending, (state: TpiReportedIssuesState) => {
        state.TpiReportedIssues.load = true;
      })
      .addCase(fetchTpiReportedIssues.fulfilled, (state: TpiReportedIssuesState, action: any) => {
        state.TpiReportedIssues.data = action.payload;
        state.TpiReportedIssues.load = false;
      })
      .addCase(fetchTpiReportedIssues.rejected, (state: TpiReportedIssuesState) => {
        state.TpiReportedIssues.load = false;
      });
  },
});

export default TpiReportedIssuesSlice.reducer;

export const fetchTpiReportedIssues = createAsyncThunk(
  "TpiReportedIssues/fetchTpiReportedIssues",
  async (param: {apiParam: {project_pin: any, layout_id: any}}, thunkAPI) => {
    try {
      const { data } = await DataServer.post("api/getTpiReportReportedIssueData", {
        project_pin: param.apiParam.project_pin,
        layout_id: param.apiParam.layout_id,
        page: 1,
        per_page: 1000
      });
      return data.data;
    } catch (error) {
    }
  }
);
